function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 0 15px #ddd;\n  margin: 30px 0;\n  padding: 40px 30px;\n  ",
        " {\n    padding: 25px 15px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  width: calc(100% - 150px);\n  flex: 1 0 100%;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  flex: 1 0 100%;\n  margin: 0;\n  justify-content: flex-end;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  margin-left: 53px;\n  > * {\n    margin-left: 7px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  min-width: 36px;\n  max-width: 36px;\n  margin-right: 17px;\n  display: flex;\n  justify-content: center;\n\n  > img {\n    width: 20px;\n    height: 20px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  max-width: 350px;\n  min-width: 300px;\n  ",
        " {\n    max-width: 100%;\n    width: 100%;\n    min-width: auto;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #aaaaaa;\n  > img {\n    width: 15px;\n    height: 15px;\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  > ",
        ":nth-child(1) {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  > ",
        ":nth-child(2) {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  margin-top: 25px;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  background: #ddf4dd;\n  padding: 20px 20px;\n  margin: 40px -30px -40px -30px;\n  font-weight: 400;\n  text-align: center;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top: 1px solid #cdc;\n  ",
        " {\n    margin: 25px -15px -25px -15px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  max-height: 400px;\n  overflow: scroll;\n  border-top: 1px solid #ccc;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  background: #eee;\n  border-spacing: 0;\n\n  thead {\n    td {\n      font-weight: 400;\n    }\n  }\n  td {\n    padding: 6px;\n    border-bottom: 1px solid #ccc;\n    text-align: left;\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: 30px;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  margin-right: 15px;\n  > img {\n    max-width: 200px;\n    max-height: 200px;\n    cursor: zoom-in;\n  }\n  > p {\n    text-align: center;\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  max-width: 800px;\n  width: 100%;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  padding: 25px 0 0 0;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import Select from '../common/Select';
import { Button as CommonButton } from 'Shared/Button';
import { mediaBreakpointDown } from 'Shared/Utility';
export var Panel = styled.div(_templateObject(), mediaBreakpointDown('sm'));
export var PanelAction = styled.div(_templateObject1());
export var PanelActionLeftContainer = styled.div(_templateObject2());
export var PanelActionRightContainer = styled.div(_templateObject3());
export var LabelContainer = styled.div(_templateObject4());
export var PanelActionIconContainer = styled.div(_templateObject5());
export var PanelActionCrossTabSelect = styled(Select)(_templateObject6(), mediaBreakpointDown('xs'));
export var Button = styled(CommonButton)(_templateObject7(), function(props) {
    return props.active && "\n    background-color:rgb(51, 102, 153);\n  ";
});
export var ButtonGroup = styled.div(_templateObject8(), Button, Button);
export var PanelBody = styled.div(_templateObject9());
export var DisqualifierPanel = styled.div(_templateObject10(), mediaBreakpointDown('sm'));
export var TableContainer = styled.div(_templateObject11());
export var Table = styled.table(_templateObject12());
export var ImageChoiceList = styled.div(_templateObject13());
export var ImageChoiceItem = styled.div(_templateObject14());
export var ZoomImage = styled.img(_templateObject15());
export var ChartContainer = styled.div(_templateObject16());
